import Tiac_Menu from "./Tiac_HambergerMenu";

export default Tiac_Menu;
